import type { ComponentPropsWithRef, FC } from 'react';

import type { ClassNameProps } from '@tripleten/cn';

import { Slot } from '../slot/slot.tsx';

import { cnVisuallyHidden } from './visually-hidden.constants.ts';

import './visually-hidden.css';

export type VisuallyHiddenProps = ClassNameProps &
    ComponentPropsWithRef<'span'> & {
        asChild?: boolean;
    };

export const VisuallyHidden: FC<VisuallyHiddenProps> = ({ asChild, className, ...props }) => {
    const Component = asChild ? Slot : 'span';

    return <Component {...props} className={cnVisuallyHidden({}, [className])} />;
};
